import { Outlet } from "react-router-dom"
const MainSubCon = () =>{

    return(
        <div className=" w-full h-full">
         <Outlet/>
        </div>
    )
}


export default MainSubCon;